module.exports = __webpack_public_path__ + "static/media/promatic.4e0c1b98.jpg";